export const googleConstants = {
  mapApiKey: 'AIzaSyDze3acRGJstoqlnLspSEucNh_83JwIWwc'
}
